var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgChevronLightRight(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.41 14.01"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#c6c6cd",
    d: "M8.41 7l-7-7L0 1.41l5.59 5.6L0 12.6l1.41 1.41 7-7V7z",
    "data-name": "Header - Opt 1 (Grey)"
  })));
}
export default SvgChevronLightRight;